import {Injectable} from "@angular/core";
import { AangifteSchenkbelasting, BokkzClient, GiftTaxEntity, SbBerekening } from './api.bokkz.services';
import { ErrorMessage, SbRekenService } from './rekenclient.api';
import {BokkzSbDataService} from "./bokkz-sb-data-service";
import {ToastService} from "@snelstart/ui-toast";

@Injectable({providedIn: 'root'})
export class BokkzSbLogic {

  public errorResponse = {} as ErrorMessage[];
  public giftTaxEntity = {} as GiftTaxEntity;
  public sbAangifte = {} as AangifteSchenkbelasting;
  public sbBerekening = {} as SbBerekening;
  public aantalValidaties = {} as number;
  public errorString = '';

  constructor(private bokkzClient: BokkzClient,
              private sbRekenservice: SbRekenService,
              public dataService: BokkzSbDataService,
              public toastService: ToastService
  ) {
    //Hier zorgen we ervoor we ervoor dat we nieuwe data binnenkrijgen en stoppen deze in de variabelen.
    this.dataService.giftTaxEntity.subscribe((value) => (this.giftTaxEntity = value));
    this.dataService.sbBerekening.subscribe((value) => (this.sbBerekening = value));
    this.dataService.errorResponse.subscribe((value) => (this.errorResponse = value));
    this.dataService.aantalValidaties.subscribe((value) => (this.aantalValidaties = value));
  }

  public getGiftTaxEntity(clientId: string, taxId: string) {
    this.bokkzClient.getGiftTax(clientId, taxId).subscribe({
      next: (result) => {
        this.dataService.updateGiftTaxEntity(result as GiftTaxEntity);
        if (result.aangifte && result.aangifte.begiftigde) {
          this.getValidation();
        }
      },
      error: (error) => {
        console.log(error);
      },
      // complete: () => console.log("complete")
    })
  }

  private getFromSessionStorage<T>(key: string): T | null {
    const value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  }

  private getEntity(): GiftTaxEntity {
    return this.getFromSessionStorage('giftTaxEntity') || {} as GiftTaxEntity;
  }

  public postGiftTaxEntity(clientId: string, sendToAuthorities: boolean) {
    this.bokkzClient.postGiftTax(clientId, sendToAuthorities, this.getEntity()).subscribe({
      next: (response) => {
        if (response && response.aangifte != null) {
          this.dataService.updateGiftTaxEntity(response)
        }
      },
      error: (err) => {
        this.toastService.showErrorMessage("De gegevens zijn niet opgeslagen.")
        console.log(err)
      },
    })
  }

  public getCalculation() {
    const aangifte = this.getEntity()?.aangifte
    if (aangifte?.schenking && this.dataService.valide.value) {
      this.sbRekenservice.getGiftTaxCalculation(aangifte).subscribe({
        next: (response) => {
          if (response.totaleSchenking != null) {
            this.dataService.updateSbBerekening(response as SbBerekening);
          }
        },
        error: (err) => {
          console.log("SB Berekening mislukt", err)
        },
        complete: () => console.log("SB Berekening succes")
      })
    }
  }

  public getValidation() {
    setTimeout(() => {
      this.sbRekenservice.getGiftTaxValidation(this.getEntity().aangifte!).subscribe({
        next: (response) => {
          if (response.totaleSchenking != null) {
            this.dataService.updateSbBerekening(response);
            this.dataService.updateAantalValidaties(0);
          } else {
            if ("HV000028: Unexpected exception during isValid call." === response as unknown as string) {
              this.errorString = response as unknown as string;
              const error: ErrorMessage[] = [{
                error: "server.error",
                response: "HV000028: Unexpected exception during isValid call."
              }]
              this.dataService.updateErrorResponse(error);
              this.dataService.updateAantalValidaties(1);
              this.dataService.updateSbBerekening(({} as SbBerekening));
            } else {
              this.dataService.updateErrorResponse(response as ErrorMessage[]);
              this.dataService.updateAantalValidaties(this.errorResponse.length);
              this.dataService.updateSbBerekening(({} as SbBerekening));
            }
          }
        },
        error: (err) => {
          this.dataService.updateAantalValidaties(0);
          console.log(err)
        },
        // complete: () => console.log("complete")
      })
    }, 1200)
  }

}
